// @flow
const newPrices = [
  {
    productCode: 'DLS-MTM-PL-250MB',
    lookupCode: 'DLS-MTM-PL-250MB-AUD',
    price: '599',
  },
  {
    productCode: 'DLS-Q3-PL-250MB',
    lookupCode: 'DLS-Q3-PL-250MB-AUD',
    price: '469',
  },
  {
    productCode: 'DLS-S6-PL-250MB',
    lookupCode: 'DLS-S6-PL-250MB-AUD',
    price: '409',
  },
  {
    productCode: 'DLS-A-PL-250MB',
    lookupCode: 'DLS-A-PL-250MB-AUD',
    price: '304',
  },
  {
    productCode: 'DLS-MTM-PR-1GB',
    lookupCode: 'DLS-MTM-PR-1GB-AUD',
    price: '1844',
  },
  {
    productCode: 'DLS-Q3-PR-1GB',
    lookupCode: 'DLS-Q3-PR-1GB-AUD',
    price: '1414',
  },
  {
    productCode: 'DLS-S6-PR-1GB',
    lookupCode: 'DLS-S6-PR-1GB-AUD',
    price: '1189',
  },
  {
    productCode: 'DLS-A-PR-1GB',
    lookupCode: 'DLS-A-PR-1GB-AUD',
    price: '879',
  },
  {
    productCode: 'DLS-MTM-PR-2GB',
    lookupCode: 'DLS-MTM-PR-2GB-AUD',
    price: '2554',
  },
  {
    productCode: 'DLS-Q3-PR-2GB',
    lookupCode: 'DLS-Q3-PR-2GB-AUD',
    price: '1959',
  },
  {
    productCode: 'DLS-S6-PR-2GB',
    lookupCode: 'DLS-S6-PR-2GB-AUD',
    price: '1654',
  },
  {
    productCode: 'DLS-A-PR-2GB',
    lookupCode: 'DLS-A-PR-2GB-AUD',
    price: '1214',
  },
  {
    productCode: 'DLS-MTM-PR-3GB',
    lookupCode: 'DLS-MTM-PR-3GB-AUD',
    price: '3039',
  },
  {
    productCode: 'DLS-Q3-PR-3GB',
    lookupCode: 'DLS-Q3-PR-3GB-AUD',
    price: '2334',
  },
  {
    productCode: 'DLS-S6-PR-3GB',
    lookupCode: 'DLS-S6-PR-3GB-AUD',
    price: '1964',
  },
  {
    productCode: 'DLS-A-PR-3GB',
    lookupCode: 'DLS-A-PR-3GB-AUD',
    price: '1444',
  },
  {
    productCode: 'DLS-MTM-PR-4GB',
    lookupCode: 'DLS-MTM-PR-4GB-AUD',
    price: '3534',
  },
  {
    productCode: 'DLS-Q3-PR-4GB',
    lookupCode: 'DLS-Q3-PR-4GB-AUD',
    price: '2834',
  },
  {
    productCode: 'DLS-S6-PR-4GB',
    lookupCode: 'DLS-S6-PR-4GB-AUD',
    price: '2289',
  },
  {
    productCode: 'DLS-A-PR-4GB',
    lookupCode: 'DLS-A-PR-4GB-AUD',
    price: '1684',
  },
  {
    productCode: 'DLS-MTM-PL-250MB',
    lookupCode: 'DLS-MTM-PL-250MB-USD',
    price: '479',
  },
  {
    productCode: 'DLS-Q3-PL-250MB',
    lookupCode: 'DLS-Q3-PL-250MB-USD',
    price: '374',
  },
  {
    productCode: 'DLS-S6-PL-250MB',
    lookupCode: 'DLS-S6-PL-250MB-USD',
    price: '329',
  },
  {
    productCode: 'DLS-A-PL-250MB',
    lookupCode: 'DLS-A-PL-250MB-USD',
    price: '244',
  },
  {
    productCode: 'DLS-MTM-PR-1GB',
    lookupCode: 'DLS-MTM-PR-1GB-USD',
    price: '1479',
  },
  {
    productCode: 'DLS-Q3-PR-1GB',
    lookupCode: 'DLS-Q3-PR-1GB-USD',
    price: '1134',
  },
  {
    productCode: 'DLS-S6-PR-1GB',
    lookupCode: 'DLS-S6-PR-1GB-USD',
    price: '959',
  },
  {
    productCode: 'DLS-A-PR-1GB',
    lookupCode: 'DLS-A-PR-1GB-USD',
    price: '699',
  },
  {
    productCode: 'DLS-MTM-PR-2GB',
    lookupCode: 'DLS-MTM-PR-2GB-USD',
    price: '2044',
  },
  {
    productCode: 'DLS-Q3-PR-2GB',
    lookupCode: 'DLS-Q3-PR-2GB-USD',
    price: '1574',
  },
  {
    productCode: 'DLS-S6-PR-2GB',
    lookupCode: 'DLS-S6-PR-2GB-USD',
    price: '1319',
  },
  {
    productCode: 'DLS-A-PR-2GB',
    lookupCode: 'DLS-A-PR-2GB-USD',
    price: '979',
  },
  {
    productCode: 'DLS-MTM-PR-3GB',
    lookupCode: 'DLS-MTM-PR-3GB-USD',
    price: '2434',
  },
  {
    productCode: 'DLS-Q3-PR-3GB',
    lookupCode: 'DLS-Q3-PR-3GB-USD',
    price: '1864',
  },
  {
    productCode: 'DLS-S6-PR-3GB',
    lookupCode: 'DLS-S6-PR-3GB-USD',
    price: '1574',
  },
  {
    productCode: 'DLS-A-PR-3GB',
    lookupCode: 'DLS-A-PR-3GB-USD',
    price: '1154',
  },
  {
    productCode: 'DLS-MTM-PR-4GB',
    lookupCode: 'DLS-MTM-PR-4GB-USD',
    price: '2824',
  },
  {
    productCode: 'DLS-Q3-PR-4GB',
    lookupCode: 'DLS-Q3-PR-4GB-USD',
    price: '2264',
  },
  {
    productCode: 'DLS-S6-PR-4GB',
    lookupCode: 'DLS-S6-PR-4GB-USD',
    price: '1829',
  },
  {
    productCode: 'DLS-A-PR-4GB',
    lookupCode: 'DLS-A-PR-4GB-USD',
    price: '1339',
  },
  {
    productCode: 'DLS-MTM-PL-250MB',
    lookupCode: 'DLS-MTM-PL-250MB-GBP',
    price: '359',
  },
  {
    productCode: 'DLS-Q3-PL-250MB',
    lookupCode: 'DLS-Q3-PL-250MB-GBP',
    price: '284',
  },
  {
    productCode: 'DLS-S6-PL-250MB',
    lookupCode: 'DLS-S6-PL-250MB-GBP',
    price: '249',
  },
  {
    productCode: 'DLS-A-PL-250MB',
    lookupCode: 'DLS-A-PL-250MB-GBP',
    price: '184',
  },
  {
    productCode: 'DLS-MTM-PR-1GB',
    lookupCode: 'DLS-MTM-PR-1GB-GBP',
    price: '1104',
  },
  {
    productCode: 'DLS-Q3-PR-1GB',
    lookupCode: 'DLS-Q3-PR-1GB-GBP',
    price: '844',
  },
  {
    productCode: 'DLS-S6-PR-1GB',
    lookupCode: 'DLS-S6-PR-1GB-GBP',
    price: '714',
  },
  {
    productCode: 'DLS-A-PR-1GB',
    lookupCode: 'DLS-A-PR-1GB-GBP',
    price: '529',
  },
  {
    productCode: 'DLS-MTM-PR-2GB',
    lookupCode: 'DLS-MTM-PR-2GB-GBP',
    price: '1534',
  },
  {
    productCode: 'DLS-Q3-PR-2GB',
    lookupCode: 'DLS-Q3-PR-2GB-GBP',
    price: '1174',
  },
  {
    productCode: 'DLS-S6-PR-2GB',
    lookupCode: 'DLS-S6-PR-2GB-GBP',
    price: '994',
  },
  {
    productCode: 'DLS-A-PR-2GB',
    lookupCode: 'DLS-A-PR-2GB-GBP',
    price: '734',
  },
  {
    productCode: 'DLS-MTM-PR-3GB',
    lookupCode: 'DLS-MTM-PR-3GB-GBP',
    price: '1829',
  },
  {
    productCode: 'DLS-Q3-PR-3GB',
    lookupCode: 'DLS-Q3-PR-3GB-GBP',
    price: '1404',
  },
  {
    productCode: 'DLS-S6-PR-3GB',
    lookupCode: 'DLS-S6-PR-3GB-GBP',
    price: '1179',
  },
  {
    productCode: 'DLS-A-PR-3GB',
    lookupCode: 'DLS-A-PR-3GB-GBP',
    price: '869',
  },
  {
    productCode: 'DLS-MTM-PR-4GB',
    lookupCode: 'DLS-MTM-PR-4GB-GBP',
    price: '2124',
  },
  {
    productCode: 'DLS-Q3-PR-4GB',
    lookupCode: 'DLS-Q3-PR-4GB-GBP',
    price: '1709',
  },
  {
    productCode: 'DLS-S6-PR-4GB',
    lookupCode: 'DLS-S6-PR-4GB-GBP',
    price: '1379',
  },
  {
    productCode: 'DLS-A-PR-4GB',
    lookupCode: 'DLS-A-PR-4GB-GBP',
    price: '1009',
  },
  {
    productCode: 'DLS-MTM-PL-250MB',
    lookupCode: 'DLS-MTM-PL-250MB-EUR',
    price: '419',
  },
  {
    productCode: 'DLS-Q3-PL-250MB',
    lookupCode: 'DLS-Q3-PL-250MB-EUR',
    price: '329',
  },
  {
    productCode: 'DLS-S6-PL-250MB',
    lookupCode: 'DLS-S6-PL-250MB-EUR',
    price: '289',
  },
  {
    productCode: 'DLS-A-PL-250MB',
    lookupCode: 'DLS-A-PL-250MB-EUR',
    price: '214',
  },
  {
    productCode: 'DLS-MTM-PR-1GB',
    lookupCode: 'DLS-MTM-PR-1GB-EUR',
    price: '1294',
  },
  {
    productCode: 'DLS-Q3-PR-1GB',
    lookupCode: 'DLS-Q3-PR-1GB-EUR',
    price: '989',
  },
  {
    productCode: 'DLS-S6-PR-1GB',
    lookupCode: 'DLS-S6-PR-1GB-EUR',
    price: '829',
  },
  {
    productCode: 'DLS-A-PR-1GB',
    lookupCode: 'DLS-A-PR-1GB-EUR',
    price: '614',
  },
  {
    productCode: 'DLS-MTM-PR-2GB',
    lookupCode: 'DLS-MTM-PR-2GB-EUR',
    price: '1789',
  },
  {
    productCode: 'DLS-Q3-PR-2GB',
    lookupCode: 'DLS-Q3-PR-2GB-EUR',
    price: '1369',
  },
  {
    productCode: 'DLS-S6-PR-2GB',
    lookupCode: 'DLS-S6-PR-2GB-EUR',
    price: '1154',
  },
  {
    productCode: 'DLS-A-PR-2GB',
    lookupCode: 'DLS-A-PR-2GB-EUR',
    price: '854',
  },
  {
    productCode: 'DLS-MTM-PR-3GB',
    lookupCode: 'DLS-MTM-PR-3GB-EUR',
    price: '2124',
  },
  {
    productCode: 'DLS-Q3-PR-3GB',
    lookupCode: 'DLS-Q3-PR-3GB-EUR',
    price: '1634',
  },
  {
    productCode: 'DLS-S6-PR-3GB',
    lookupCode: 'DLS-S6-PR-3GB-EUR',
    price: '1379',
  },
  {
    productCode: 'DLS-A-PR-3GB',
    lookupCode: 'DLS-A-PR-3GB-EUR',
    price: '1009',
  },
  {
    productCode: 'DLS-MTM-PR-4GB',
    lookupCode: 'DLS-MTM-PR-4GB-EUR',
    price: '2474',
  },
  {
    productCode: 'DLS-Q3-PR-4GB',
    lookupCode: 'DLS-Q3-PR-4GB-EUR',
    price: '1989',
  },
  {
    productCode: 'DLS-S6-PR-4GB',
    lookupCode: 'DLS-S6-PR-4GB-EUR',
    price: '1599',
  },
  {
    productCode: 'DLS-A-PR-4GB',
    lookupCode: 'DLS-A-PR-4GB-EUR',
    price: '1179',
  },
  {
    productCode: 'DLS-MTM-PL-250MB',
    lookupCode: 'DLS-MTM-PL-250MB-ZAR',
    price: '6487',
  },
  {
    productCode: 'DLS-Q3-PL-250MB',
    lookupCode: 'DLS-Q3-PL-250MB-ZAR',
    price: '5514',
  },
  {
    productCode: 'DLS-S6-PL-250MB',
    lookupCode: 'DLS-S6-PL-250MB-ZAR',
    price: '4865',
  },
  {
    productCode: 'DLS-A-PL-250MB',
    lookupCode: 'DLS-A-PL-250MB-ZAR',
    price: '3892',
  },
  {
    productCode: 'DLS-MTM-PR-1GB',
    lookupCode: 'DLS-MTM-PR-1GB-ZAR',
    price: '16887',
  },
  {
    productCode: 'DLS-Q3-PR-1GB',
    lookupCode: 'DLS-Q3-PR-1GB-ZAR',
    price: '14354',
  },
  {
    productCode: 'DLS-S6-PR-1GB',
    lookupCode: 'DLS-S6-PR-1GB-ZAR',
    price: '12665',
  },
  {
    productCode: 'DLS-A-PR-1GB',
    lookupCode: 'DLS-A-PR-1GB-ZAR',
    price: '10132',
  },
  {
    productCode: 'DLS-MTM-PR-2GB',
    lookupCode: 'DLS-MTM-PR-2GB-ZAR',
    price: '23387',
  },
  {
    productCode: 'DLS-Q3-PR-2GB',
    lookupCode: 'DLS-Q3-PR-2GB-ZAR',
    price: '19879',
  },
  {
    productCode: 'DLS-S6-PR-2GB',
    lookupCode: 'DLS-S6-PR-2GB-ZAR',
    price: '17540',
  },
  {
    productCode: 'DLS-A-PR-2GB',
    lookupCode: 'DLS-A-PR-2GB-ZAR',
    price: '14032',
  },
  {
    productCode: 'DLS-MTM-PR-3GB',
    lookupCode: 'DLS-MTM-PR-3GB-ZAR',
    price: '27937',
  },
  {
    productCode: 'DLS-Q3-PR-3GB',
    lookupCode: 'DLS-Q3-PR-3GB-ZAR',
    price: '23746',
  },
  {
    productCode: 'DLS-S6-PR-3GB',
    lookupCode: 'DLS-S6-PR-3GB-ZAR',
    price: '20953',
  },
  {
    productCode: 'DLS-A-PR-3GB',
    lookupCode: 'DLS-A-PR-3GB-ZAR',
    price: '16762',
  },
  {
    productCode: 'DLS-MTM-PR-4GB',
    lookupCode: 'DLS-MTM-PR-4GB-ZAR',
    price: '32487',
  },
  {
    productCode: 'DLS-Q3-PR-4GB',
    lookupCode: 'DLS-Q3-PR-4GB-ZAR',
    price: '27614',
  },
  {
    productCode: 'DLS-S6-PR-4GB',
    lookupCode: 'DLS-S6-PR-4GB-ZAR',
    price: '24365',
  },
  {
    productCode: 'DLS-A-PR-4GB',
    lookupCode: 'DLS-A-PR-4GB-ZAR',
    price: '19492',
  },
];

const getPrices = () => newPrices;

const defaultProps = {
  lookingForTenderPricingText: 'Looking for Tenders pricing?',
  findOutMoreText: 'Find out more',
  findOutMoreUrl: 'https://get.ansarada.com/tender-pricing',

  getStartedTitle: 'Get started today for free',
  getStartedDetails:
    'Prepare your deal for free. Your subscription begins when you invite your first guest.',
  getStartedDetails2: 'No credit card required.',

  getPrices,
};

export default defaultProps;
